module.exports = __webpack_public_path__ + "img/tcApi_step2.61a532e1.png";